export default {
  label: "Home",
};
